import { render } from "./ItemForm.vue?vue&type=template&id=357b7e84&scoped=true&bindings={\"isOpen\":\"props\",\"items\":\"setup\",\"add\":\"setup\",\"isDragging\":\"setup\",\"remove\":\"setup\",\"tab\":\"setup\",\"itemsJson\":\"setup\",\"makeExportCopy\":\"setup\",\"hasExported\":\"setup\",\"importInput\":\"setup\",\"importData\":\"setup\",\"shuffleItems\":\"setup\",\"clearItems\":\"setup\",\"resetItems\":\"setup\",\"setSelection\":\"setup\"}"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"

import "./ItemForm.vue?vue&type=style&index=0&id=357b7e84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-357b7e84"

export default script